module.exports = "<!--Notification-->\n<pcg-ng-notification></pcg-ng-notification>\n"